import { motion } from "framer-motion";

const LIGHTS = [
  { x: "76.4%", y: "72.4%", w: 22 },
  { x: "95.6%", y: "74.4%", w: 13 },
  { x: "75.8%", y: "79.8%", w: 9 },
];
const BLINK = [0, 1, 1, 0, 0, 1, 1, 0];

export const Headlights = ({ on }) => (
  <div className="pointer-events-none absolute inset-0" aria-hidden="true">
    {LIGHTS.map((l, i) => (
      <span key={i} className="absolute -translate-x-1/2 -translate-y-1/2" style={{ left: l.x, top: l.y, width: `${l.w}%`, aspectRatio: "1.6" }}>
        <motion.span
          className="block h-full w-full rounded-full mix-blend-screen"
          style={{ background: "radial-gradient(closest-side, #fff 0%, rgba(235,245,255,.9) 28%, rgba(200,225,255,.4) 60%, transparent 100%)", filter: "blur(2px)" }}
          initial={{ opacity: 0, scale: 0.6 }}
          animate={on ? { opacity: BLINK, scale: [0.6, 1.1, 1, 0.7, 0.6, 1.1, 1, 0.7] } : { opacity: 0, scale: 0.6 }}
          transition={on ? { duration: 1.6, repeat: Infinity, ease: "easeInOut" } : { duration: 0.3 }}
        />
      </span>
    ))}
    <motion.span
      className="absolute inset-0 mix-blend-screen"
      style={{ background: "radial-gradient(40% 30% at 84% 76%, rgba(220,235,255,.35), transparent 70%)" }}
      initial={{ opacity: 0 }}
      animate={on ? { opacity: BLINK } : { opacity: 0 }}
      transition={on ? { duration: 1.6, repeat: Infinity, ease: "easeInOut" } : { duration: 0.3 }}
    />
  </div>
);
